<ion-header>
  <ion-toolbar>
    <ion-title>Ranking</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-refresher (ionRefresh)="onRefresh($event)" slot="fixed">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>
  <ranking-list *ngIf="boulders else loading" [showHeader]="false" [boulders]="boulders"></ranking-list>
</ion-content>
<ng-template #loading>
  <br><br>
  <h2>{{"ranking-page.load-ranking" | translate}}</h2>
  <p>{{"shared.please-wait" | translate}}</p>
</ng-template>
